export default() => {
    const routes = {
        'custom-signals/v2/custom-pro/new/save/': true,
        '/custom-signals/custom-pro/setup/': true,
        'custom-signals/v2/custom-pro/backtest/': true,
        '/membership/package/status/': true,
    }
    return {
        routes
    };
};